module.exports = __webpack_public_path__ + "assets/img/search_input.dd018ea1.png";